'use strict';
module.exports = require('./lib/index.js');



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/index.js
// module id = 954
// module chunks = 0